export const GET_ACCOUNTS_PROJECT_CONFIG = "get-accounts-project-configs";
export const GET_ACCOUNTS_TOS_INFO = "get-accounts-tos-info";
export const GET_ALL_GAS_MANAGER_POLICIES = "get-all-gas-policies";
